'use client'

import { useStateStore } from "@/context/stateStore";
import { useDisclosure } from "@mantine/hooks";
import { usePathname } from "next/navigation";
import MainHeader from "../nav/header";
import ActionsDrawer from "../drawers/actions-drawer";
import NavDrawer from "../drawers/nav-drawer";
import { useHomeStore } from "@/context/homePageStore";
import { FaSeedling, FaStickyNote } from "react-icons/fa";
import { GiCycle, GiCog } from "react-icons/gi";
import { JSX, useEffect, useState } from "react";

export interface TabItem {
    title: string;
    label: string;
    icon: JSX.Element;
}

export default function NavWrapper() {

    const tabManifest = [
        [
            { icon: <FaSeedling size={16} />, label: `Details`, title: 'Plant' },
            { icon: <FaStickyNote size={16} />, label: `Notes`, title: 'Notes' },
            { icon: <GiCycle size={16} />, label: `Growing`, title: 'Growing' }
        ],
        [
            { icon: <FaSeedling size={16} />, label: `Plant Info`, title: 'Plant' },
            { icon: <FaStickyNote size={16} />, label: `Notes`, title: 'Notes' },
            { icon: <GiCog size={16} />, label: `Growing Session`, title: 'Growing' },
        ]
    ] as TabItem[][];


    const pathname = usePathname();
    const setGlobalLoading = useStateStore(state => state.setGlobalLoading);
    const [specificPageBool, setSpecificPageBool] = useState<boolean>(false);
    const [opened, { open, close }] = useDisclosure(false);
    const [openedActions, { open: openActions, close: closeActions }] = useDisclosure(false);
    const [trackedPath, setTrackedPath] = useState<string>('');
    const [specName, setSpecName] = useState<string>('');
    const [specificObjectName, setSpecificObjectName] = useState<string>('');
    const [tabs, setTabs] = useState<TabItem[]>([]);
    const width = useStateStore(state => state.widthQuery);
    const specificTab = useStateStore(state => state.specificTab);
    const editList = useHomeStore(state => state.editList);
    const userVerified = useStateStore((state) => state.userVerified);

    const setHeaderDetails = async () => {
        setTrackedPath(pathname);
        if (pathname.includes('/plants/')) {
            setTabs(tabManifest[0]);
            setSpecName('Plants');
            setSpecificPageBool(true);
            setSpecificObjectName(useStateStore.getState().currPlant.name || '');
        } else if (pathname === '/plants') {
            setTabs(tabManifest[0]);
            setSpecName('Plants');
            setSpecificPageBool(false);
        } else if (pathname.includes('/growing/')) {
            setTabs(tabManifest[1]);
            setSpecName('Growing');
            setSpecificPageBool(true);
            setSpecificObjectName(useStateStore.getState().currCycle.name || '');
        } else if (pathname === '/growing') {
            setTabs(tabManifest[1]);
            setSpecName('Growing');
            setSpecificPageBool(false);
        } else if (pathname.startsWith('/catalog')) {
            setTabs([] as TabItem[]);
            setSpecName('Plant Info');
            setSpecificPageBool(false);
        } else if (pathname.includes('/notes/')) {
            setTabs([] as TabItem[]);
            setSpecName('Notes');
            setSpecificPageBool(false);
            setSpecificObjectName(useStateStore.getState().currNote.noteName || '');
        } else if (pathname === '/notes') {
            setTabs([] as TabItem[]);
            setSpecName('Notes');
            setSpecificPageBool(false);
        } else {
            setTabs([] as TabItem[]);
            setSpecName('');
            setSpecificPageBool(false);
        }
    }

    useEffect(() => {
        if (trackedPath !== pathname) {
            setGlobalLoading(true);
            const init = async () => {
                await setHeaderDetails();
            }
            init();
        }
        setGlobalLoading(false);
    }, [pathname, trackedPath]);

    return (
        <section className="flex flex-col justify-start items-center w-screen h-fit">
            <NavDrawer opened={opened} close={close} setGlobalLoading={setGlobalLoading} userVerified={userVerified} />
            {userVerified && <ActionsDrawer openedActions={openedActions} closeActions={closeActions} />}
            <MainHeader pathname={pathname} openActions={openActions} opened={opened} width={width} open={open} editList={editList} currName={specName} specificTab={specificTab} tabs={tabs} specificPageBool={specificPageBool} specificObjectName={specificObjectName} userVerified={userVerified} />
        </section>
    )
}

//home links wants to just go backwards like I'm linking it to router and then doing /home, but I have it doing "/", so need to change
